module.exports = __webpack_public_path__ + "static/media/rxr pro xp.df7692f8.usdz";